<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    title="设置课时"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >

       <Form-item label="总费用" prop="classMoney">
        <InputNumber
          :min="0"
          :max="100000"
          v-model="cForm.model.classMoney"
        />
      </Form-item>

      <Form-item label="总课时" prop="classHours">
        <InputNumber :min="0" :max="100000" v-model="cForm.model.classHours" />
      </Form-item>
      <Form-item label="已用课时" prop="usedClassHours">
        <InputNumber
          :min="0"
          :max="100000"
          v-model="cForm.model.usedClassHours"
        />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "classStudents";

@Component({
  mixins: [FormMixin]
})
export default class ClassHoursForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {}
      }
    };
  }

  getFormInitModel() {
    return {
      classHours: 0,
      usedClassHours: 0
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success("设置成功");
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
